import { client } from '@/api/client';
import {
    GetPrintBadgeRegistrationDetails,
    GetPrintBadgeRegistrationDetailsResponse
} from '@/api/dtos';
import useSWRMutation from 'swr/mutation';

async function getPrintBadgeRegistrationDetailsFetcher(
    _key: string,
    { arg }: { arg: GetPrintBadgeRegistrationDetails }
): Promise<GetPrintBadgeRegistrationDetailsResponse> {
    return (await client.post(arg as any)) as GetPrintBadgeRegistrationDetailsResponse;
}

export const useGetPrintBadgeRegistrationDetails = () => {
    const { trigger, data, error, isMutating } = useSWRMutation(
        'GetPrintBadgeRegistrationDetails',
        getPrintBadgeRegistrationDetailsFetcher
    );

    return {
        getPrintBadgeRegistrationDetails: trigger,
        data,
        error,
        pending: isMutating,
    };
};

export default useGetPrintBadgeRegistrationDetails;
